export default __webpack_public_path__ + "static/media/menu.dafc4414.svg";